import React from 'react';
import './App.css';
import { StyleRoot } from 'radium';
import AddressAutoComplete from './components/AddressAutoComplete.js';
import Button from './components/Button.js';
import InputSelect from './components/Input.js';
import InputText from './components/InputText.js';
import { Map, GoogleApiWrapper, Marker } from 'google-maps-react';
import Mapd from './components/Mapd.js';

class App extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      book: false,
      message: '',
      address2: '-',
      address1: '-',
      distance: '',
      length: '0',
      width: '0',
      depth: '0',
      item: '',
      price: '0',
      car: 'Small van',
      showmap: false,
      myArray: [
        { lat: -34.397, lng: 150.644 },
        { lat: -24.397, lng: 140.644 },
        { lat: -14.397, lng: 130.644 },
      ]
    };

    this.getDistance = this.getDistance.bind(this);
    this.sendmail = this.sendmail.bind(this);
    this.book = this.book.bind(this);
    this.back = this.back.bind(this);

  }

  async getDistance(origin, destination) {


    const directionsService = new window.google.maps.DirectionsService();

    const orig = { lat: this.state.origlat, lng: this.state.origlng };
    const dest = { lat: this.state.destlat, lng: this.state.destlng };

    directionsService.route(
      {
        origin: orig,
        destination: dest,
        travelMode: window.google.maps.TravelMode.DRIVING
      },
      (result, status) => {
        if (status === window.google.maps.DirectionsStatus.OK) {
          this.setState({
            directions: result
          });
        } else {
          console.error(`error fetching directions ${result}`);
        }
      }
    );


    var service = new window.google.maps.DistanceMatrixService();
    let promise = service.getDistanceMatrix(
      {
        origins: [origin],
        destinations: [destination],
        travelMode: 'DRIVING'
      }, callback.bind(this));

    function callback(response, status) {
      //console.log(response)
      let d = (response.rows[0].elements[0].distance.value / 1000) * 0.621371;
      this.setState({
        distance: d.toFixed(2)
      }, () => {
        this.getCost();

      });
      //console.log(this.state.distance)
    }
    return promise;
  }


  book() {
    this.setState({
      book: true
    })
  }

  back() {
    this.setState({
      book: false
    })
  }

  adress1change(address, geo) {

    this.setState({
      address1: address,
      origlat: geo[0],
      origlng: geo[1]
    }, () => {
      this.getDistance(this.state.address1, this.state.address2)
      //console.log(this.state.lat)
      //console.log(this.state.lng)

    })

  }

  adress2change(address, geo) {
    this.setState({
      address2: address,
      destlat: geo[0],
      destlng: geo[1]
    }, () => {
      this.getDistance(this.state.address1, this.state.address2).then(
        this.setState({
          showmap: true
        })
      )
      //console.log(this.state.lat)
      //console.log(this.state.lng)
    })

  }

  getCost() {
    let distance = this.state.distance
    let price = 0;

    switch (this.state.car) {

      case 'Small van':
        for (let i = 0; i < distance; i++) {
          if (i <= 10) { price = 49; console.log('i<=10 ' + price + ' i ' + i) }
          if (i >= 11 && i < 15) { price += 50; console.log('11-15 ' + price + ' i ' + i ) }
          if (i >= 16 && i < 20) { price += 1.5; console.log('16-20 ' + price + ' i ' + i) }
          if (i >= 21 && i < 140) { price += 0.8; console.log('21-140 ' + price + ' i ' + i) }
          if (i > 140) {
            price += 0.95; console.log('140+ ' + price + ' i ' + i)
          }
        }
        //if (distance > 140) {
        //  price -= 49
       // }
        break;

      case 'Large van':
        for (let i = 0; i < distance; i++) {
          if (i <= 10) { price = 65; console.log('i<=10 ' + price + ' i ' + i) }
          if (i >= 11 && i < 21) { price += 1; console.log('11-20 ' + price + ' i ' + i) }
          if (i >= 21 && i < 61) { price += 0.8; console.log('21-60 ' + price + ' i ' + i) }
          if (i >= 61 && i < 121) { price += 1; console.log('61-140 ' + price + ' i ' + i) }
          if (i > 141) {
            price += 1.25; console.log('230+ ' + price + ' i ' + i)
          }
        }
      //  if (distance > 230) {
      //    price -= 65
      //  }
        break;

      case 'Extra large':
        for (let i = 0; i < distance; i++) {
          if (i <= 10) { price = 80; console.log('i<=10 ' + price + ' i ' + i) }
          if (i >= 11 && i < 16) { price += 2; console.log('11-15 ' + price + ' i ' + i) }
          if (i >= 16 && i < 21) { price += 1.5; console.log('16-20 ' + price + ' i ' + i) }
          if (i >= 21 && i < 31) { price += 1.3; console.log('21-30 ' + price + ' i ' + i) }
          if (i >= 31 && i < 41) { price += 1.2; console.log('31-40 ' + price + ' i ' + i) }
          if (i >= 41 && i < 121) { price += 1.15; console.log('41-120 ' + price + ' i ' + i) }
          if (i > 121) {
            price += 1.40; console.log('250+ ' + price + ' i ' + i)
          }
        }
       // if (distance > 250) {
       //   price -= 80
       // }
        break;

      default:
        break;
    }
    this.setState({
      price: price.toFixed(2),
    })


  }

  sendmail() {

    if (this.state.username && this.state.useremail && this.validateEmail(this.state.useremail)) {
      this.setState({
        message: 'Name and email fields are valid. Attempting to send email.'
      }, () => {
        let name = this.state.username;
        let email = this.state.useremail;
        let amount = this.state.price;
        let address1 = this.state.address1;
        let address2 = this.state.address2;

        this.sendMail(name, email, amount, address1, address2)
      })
    } else {
      this.setState({
        message: 'Name and email fields are mandatory. Email address must be valid, name cannot be empty.'
      })
    }
  }

  validateEmail(mail) {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
      return (true)
    }
    //alert("You have entered an invalid email address!")
    return (false)
  }

  // sends an email to the user

  sendMail = (Name, Email, Amount, Address1, Address2) => {

    var formData = new FormData();
    formData.append('email', this.state.useremail);
    formData.append('name', this.state.username);
    formData.append('amount', this.state.price);
    formData.append('address1', this.state.address1);
    formData.append('address2', this.state.address2);
    formData.append('distance', this.state.distance);
    formData.append('length', this.state.length);
    formData.append('width', this.state.width);
    formData.append('depth', this.state.depth);
    formData.append('car', this.state.car);
    formData.append('package', this.state.item);
    formData.append('phone', this.state.phone);
    formData.append('time', this.state.phone);

    const request = new Request('./static/backend/mail.php',
      {
        method: 'POST',
        body: formData,
        headers: {
          "Access-Control-Allow-Origin": "*"
        }
      });

    fetch(request)
      .then(response => {
        if (response.status === 200) {
          return response.text();
        } else {
          throw new Error('Something went wrong on api server!');
        }
      })
      .then(body => {
        console.debug(body);
        this.setState({
          message: 'Success. Email has been sent.: ' + body
        })
        // ...
      }).catch(error => {
        this.setState({
          message: error
        })
      });
  }

  getInput(value) {

    this.setState({ [value[1]]: value[0] }, () => {
      this.getCost()
    })
  }
  render() {

    const mainContainer = {
      margin: '30px auto', // t,l,b,r
      backgroundColor: '#fff',
      boxSizing: 'border-box',
      width: '90%',
      padding: '40px',
      align: 'left',
      overflow: 'auto',
      boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',

      '@media (max-width: 992px)': {
        display: 'block',
        width: '100%',
        overflow: 'auto',
        margin: '0 auto',
        padding: '10px',
        boxSizing: 'border-box'
      },

      '@media print': {
        width: '100%',
        margin: '0',
        padding: '0',
        boxShadow: '0px 0px 0px 0px transparent',
      }
    }

    const leftColumn = {
      // For desktops
      display: 'inline',
      width: '48%',
      float: 'left',
      marginBottom: '20px',

      // For mobile
      '@media (max-width: 992px)': {
        display: 'block',
        float: 'left',
        width: '100%'
      }
    }

    const rightColumn = {
      // For desktops
      display: 'inline',
      width: '48%',
      float: 'right',
      marginBottom: '20px',

      // For mobile
      '@media (max-width: 992px)': {
        display: 'block',
        float: 'left',
        width: '100%'
      }
    }


    const thirdColumnLeft = {
      // For desktops
      display: 'inline',
      width: '31.2%',
      float: 'left',
      marginBottom: '20px',
      marginRight: '3%',

      // For mobile
      '@media (max-width: 992px)': {
        display: 'block',
        float: 'left',
        width: '100%'
      }
    }

    const thirdColumnRight = {
      // For desktops
      display: 'inline',
      width: '31.2%',
      float: 'right',
      marginBottom: '20px',

      // For mobile
      '@media (max-width: 992px)': {
        display: 'block',
        float: 'left',
        width: '100%'
      }
    }

    const thirdColumnMiddle = {
      // For desktops
      display: 'inline',
      width: '31.2%',
      float: 'left',

      // For mobile
      '@media (max-width: 992px)': {
        display: 'block',
        float: 'left',
        width: '100%'
      }
    }

    const resultlabel = {
      fontWeight: '600'
    }

    const ProductColumn = {
      // For desktops
      display: 'inline',
      width: '100%',
      float: 'left',

      // For mobile
      '@media (max-width: 992px)': {
        display: 'block',
        float: 'left',
        width: '100%'
      }
    }

    const res = {
      float: 'right',
      fontWeight: '700'
    }


    const restotal = {
      float: 'right',
      fontWeight: '700',
      fontSize: '20px',
      color: '#BE1C03'
    }

    const evenrow = {
      padding: '5px'
    }

    const oddrow = {
      padding: '5px',
      backgroundColor: '#F2F2F2'
    }

    const message = {
      paddingTop: '10px',
      fontWeight: '600'
    }





    return (

      <StyleRoot>
        <div >



          <div style={mainContainer}>







            {this.state.book ?

              <>
                <h1 style={{ color: '#BE1C03' }}>Book now</h1>
                <div style={ProductColumn}>
                  <div>
                    <div style={thirdColumnLeft}>
                      <h3>Name</h3>
                      <InputText fieldname="username" getValue={(value => this.getInput(value))} inputtype="text"></InputText>
                    </div>

                    <div style={thirdColumnMiddle}>
                      <h3>Email address</h3>
                      <InputText fieldname="useremail" getValue={(value => this.getInput(value))} inputtype="text"></InputText>
                    </div>
                  </div>

                  <div>
                    <div style={thirdColumnRight}>
                      <h3>Contact number</h3>
                      <InputText fieldname="phone" getValue={(value => this.getInput(value))} inputtype="text"></InputText>
                    </div>
                  </div>

                </div>

                <div style={ProductColumn}>

                  <div style={thirdColumnLeft}>
                    <h3>Collection address</h3>
                    <AddressAutoComplete onChange={this.adress1change.bind(this)} />
                  </div>

                  <div style={thirdColumnMiddle}>
                      <h3>Collection time</h3>
                      <InputText placeholder="Now/withing one hour OR enter time" fieldname="time" getValue={(value => this.getInput(value))} inputtype="text"></InputText>
                    </div>

                  <div style={thirdColumnRight}>
                    <h3>Delivery address</h3>
                    <AddressAutoComplete onChange={this.adress2change.bind(this)} />
                  </div>

                </div>
                <div>
                  <p>When you click SEND BOOKING, and email will be sent with the calculated data to the administrator. A copy will be sent to your email address as well. </p>
                </div>
                <Button onClick={this.sendmail} buttontext="SEND BOOKING"></Button>
                <div onClick={this.back} style={{ textAlign: 'center', cursor: 'pointer' }}>GO BACK</div>
                <div style={message}>{this.state.message}</div> </> :

              <>
                <h1 style={{ color: '#BE1C03' }}>Quote calculator</h1>
                <div style={ProductColumn}>

                  <div style={leftColumn}>
                    <h3>Collection town or postcode</h3>
                    <AddressAutoComplete onChange={this.adress1change.bind(this)} />
                  </div>

                  <div style={rightColumn}>
                    <h3>Delivery town or postcode</h3>
                    <AddressAutoComplete onChange={this.adress2change.bind(this)} />
                  </div>
                  <div>


                    <div>


                      <Mapd
                        googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDJ2bsgQjhwJGhW0pteeFty72uQfBfiy_o"
                        directions={this.state.directions}
                      />
                    </div>

                    <div>



                    </div>
                  </div>


                </div>


                <div style={ProductColumn}>
                  <div>
                    <div style={leftColumn}>
                      <h3>Car type</h3>
                      <InputSelect fieldname="car" getValue={(value => this.getInput(value))}></InputSelect>
                    </div>

                    <div style={rightColumn}>
                      <h3>Brief description of goods</h3>
                      <InputText fieldname="item" getValue={(value => this.getInput(value))} inputtype="text"></InputText>
                    </div>
                  </div>

                </div>
                {/* A JSX comment
            <div style={ProductColumn}>
              <div>
                <div style={thirdColumnLeft}>
                  <h3>package length</h3>
                  <InputText fieldname="length" getValue={(value => this.getInput(value))} inputtype="cm" ></InputText>
                </div>

                <div style={thirdColumnMiddle}>
                  <h3>Package width</h3>
                  <InputText fieldname="width" getValue={(value => this.getInput(value))} inputtype="cm"></InputText>
                </div>
                <div style={thirdColumnRight}>
                  <h3>Package depth</h3>
                  <InputText fieldname="depth" getValue={(value => this.getInput(value))} inputtype="cm"></InputText>
                </div>
              </div>
            </div>
 */}
                <div style={{ boxSizing: 'border-box', padding: '15px', border: '1px solid #BE1C03', overflow: 'auto', width: '100%' }}>

                  <h1 style={{ color: '#BE1C03' }}>Price</h1>
                  <div style={ProductColumn}>
                    {/*
                <h2>Route:</h2>
                <div style={evenrow}><span style={resultlabel}>Origin:</span> <span style={res}>{this.state.address1}</span></div>
                <div style={oddrow}><span style={resultlabel}>Destinaton: </span><span style={res}>{this.state.address2}</span></div>
                <div style={evenrow}><span style={resultlabel}>Distance: </span><span style={res}>{this.state.distance} miles</span></div>
                <div style={oddrow}><span style={resultlabel}>Car type: </span><span style={res}>{this.state.car}</span></div>
                <h2>Package:</h2>
                <div style={evenrow}><span style={resultlabel}>Item description: </span><span style={res}>{this.state.item}</span></div>
                <div style={oddrow}><span style={resultlabel}>package length: </span><span style={res}>{this.state.length} cm</span></div>
                <div style={evenrow}><span style={resultlabel}>package width: </span><span style={res}>{this.state.width} cm</span></div>
                <div style={oddrow}><span style={resultlabel}>package depth: </span><span style={res}>{this.state.depth} cm</span></div>

*/}
                    <div><span style={resultlabel}>Shipping price: </span><span style={restotal}>£{this.state.price}</span></div>
                    <div>(Congestion & surcharges may apply)</div>
                  </div>


                </div>




                <Button onClick={this.book} buttontext="BOOK ONLINE NOW"></Button>
                <div style={{ textAlign: 'center', fontSize: '18px' }}>or call to speak to us: 07738 920 906</div>


              </>

            }



          </div>

        </div>
      </StyleRoot>

    );
  }

}

export default GoogleApiWrapper({
  apiKey: 'AIzaSyDJ2bsgQjhwJGhW0pteeFty72uQfBfiy_o'
})(App);

